import React from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { MultiSelect } from './inputs/MultiSelect';

const options = [
  { value: 'published', label: 'Activas' },
  { value: 'pending', label: 'Pendientes' },
  { value: 'paused', label: 'Pausadas' },
  { value: 'finished', label: 'Finalizadas' }
];

export const StatusFilter = ({ setFiltersAndSort, filtersAndSort }) => {
  const onChange = selected => {
    setFiltersAndSort({
      ...filtersAndSort,
      status: selected.map(s => s.value)
    });
  };

  const value = filtersAndSort.status.map(status => ({
    value: status,
    label: options.find(opt => opt.value === status)?.label
  }));

  return (
    <Form.Group>
      <Form.Label>Estados</Form.Label>

      <MultiSelect
        options={options}
        value={value}
        onChange={onChange}
        placeholder="Estados"
      />
    </Form.Group>
  );
};

StatusFilter.propTypes = {
  setFiltersAndSort: PropTypes.func.isRequired,
  filtersAndSort: PropTypes.object.isRequired
};
